import { createIntl } from '@alilc/lowcode-editor-core';
import enUS from './en-US.json';
import zhCN from './zh-CN.json';
var _createIntl = createIntl({
    'en-US': enUS,
    'zh-CN': zhCN
  }),
  intl = _createIntl.intl,
  intlNode = _createIntl.intlNode,
  getLocale = _createIntl.getLocale,
  setLocale = _createIntl.setLocale;
export { intl, intlNode, getLocale, setLocale };